// https://github.com/alphagov/govuk-frontend/tree/master/src/components/
import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { ERROR_COLOUR } from 'govuk-colours';
import { SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledLabel = styled('label')({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  ':after': {
    content: "''",
    display: 'table',
    clear: 'both'
  }
}, function (_ref) {
  var error = _ref.error;
  return {
    borderLeft: error ? "4px solid " + ERROR_COLOUR : undefined,
    marginRight: error ? SPACING.SCALE_3 : undefined,
    paddingLeft: error ? SPACING.SCALE_2 : undefined
  };
});
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <Label>Example</Label>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk-frontend/tree/master/src/components/
 *
 */

var Label = function Label(props) {
  return React.createElement(StyledLabel, props);
};

export default withWhiteSpace({
  marginBottom: 0
})(Label);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/label/es/index.js
// module id = 16
// module chunks = 0